const fallbackNumber = "628123456789";

export const slideDeckUrl = "https://csjw.zarazehan.my.id/slidedeck/";

export function getWhatsAppNumber() {
  return (import.meta.env.VITE_WHATSAPP_NUMBER || fallbackNumber).replace(/\D/g, "");
}

export const freeBuildTemplate = `#CSJW

Nama usaha:
Produk:
Harga:
Deskripsi singkat:

Lampirkan:
1. Foto produk
2. Gambar QRIS`;

export function getWhatsAppUrl(message = freeBuildTemplate) {
  return `https://wa.me/${getWhatsAppNumber()}?text=${encodeURIComponent(message)}`;
}
